import { useJsApiLoader } from '@react-google-maps/api';
import { GOOGLE_MAPS_LOADER_ID, GOOGLE_MAPS_LOADER_LIBRARIES, getGoogleMapsApiKey } from './googleMapsLoaderConfig';

export default function useFleetGoogleMaps() {
  const googleMapsApiKey = getGoogleMapsApiKey();
  const { isLoaded, loadError } = useJsApiLoader({
    id: GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey,
    libraries: GOOGLE_MAPS_LOADER_LIBRARIES,
  });
  return { isLoaded, loadError, googleMapsApiKey };
}
